module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "订单详情"
    }
  }), _vm._v(" "), (_vm.order.address) ? _c('div', {
    staticClass: "box1"
  }, [_c('div', [_c('span', [_c('i', {
    staticClass: "iconfont icon-weizhi"
  }), _vm._v("收件人：" + _vm._s(_vm.order.address.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.address.mobileNumber))])]), _vm._v(" "), _c('div', [_vm._v("\n            收货地址：" + _vm._s(_vm.order.address.area) + " " + _vm._s(_vm.order.address.location) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "commodity "
  }, [_vm._l((_vm.order.products), function(item) {
    return _c('router-link', {
      key: item.num,
      staticClass: "product vux-1px-b",
      attrs: {
        "tag": "div",
        "to": {
          name: 'detail',
          params: {
            id: item.product
          }
        }
      }
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + item.thumbnail + '?x-oss-process=image/resize,w_120',
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-1 info text-l"
    }, [_c('div', {
      staticClass: "ellipsis-2"
    }, [_vm._v(_vm._s(item.title)), (item.specLabel) ? _c('span', [_vm._v("(" + _vm._s(item.specLabel) + ")")]) : _vm._e(), (item.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.subTitle))])]), _vm._v(" "), _c('div', {
      staticClass: "flex price-num"
    }, [_c('span', {
      staticClass: "pirce"
    }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(item.price)))]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("X" + _vm._s(item.quantity))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "total-info"
  }, [_vm._v("\n            共 " + _vm._s(_vm.totalCount(_vm.order)) + " 件\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "info2"
  }, [_c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("订单编号")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm.order.orderNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("下单时间")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm._f("dateToString")(_vm.order.createdAt)))])]), _vm._v(" "), (_vm.order.shippingMethod) ? _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("配送方式")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm.order.shippingMethod.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("订单金额")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.order.amount)))])]), _vm._v(" "), _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("运费")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.order.freight)))])]), _vm._v(" "), (_vm.order.discount) ? _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("优惠")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.order.discount)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("应付金额")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.order.payable)))])]), _vm._v(" "), _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("订单状态")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm._f("orderStatus")(_vm.order.status)))])]), _vm._v(" "), (_vm.order.paymentMethod) ? _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("支付方式")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm._f("paymentMethod")(_vm.order.paymentMethod)))])]) : _vm._e(), _vm._v(" "), (_vm.order.paymentTime) ? _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("付款时间")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm._f("dateToString")(_vm.order.paymentTime)))])]) : _vm._e(), _vm._v(" "), (_vm.order.shippingInfo && _vm.order.shippingInfo.company) ? _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("物流公司")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm.order.shippingInfo.company))])]) : _vm._e(), _vm._v(" "), (_vm.order.shippingInfo && _vm.order.shippingInfo.number) ? _c('div', {
    staticClass: "text-l"
  }, [_c('span', [_vm._v("运单编号")]), _vm._v(" "), _c('p', {
    staticClass: "fr color-666"
  }, [_vm._v(_vm._s(_vm.order.shippingInfo.number))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "has-footer"
  }), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "l vux-1px-t"
  }, [_vm._v("\n            " + _vm._s(_vm._f("orderStatus")(_vm.order.status)) + "\n        ")]), _vm._v(" "), (_vm.order.status == 'paid' || _vm.order.status == 'shipped' || _vm.order.status == 'received') ? _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.refundOrder(_vm.order._id)
      }
    }
  }, [_vm._v("申请退款")]) : _vm._e(), _vm._v(" "), (_vm.order.status == 'unpaid') ? _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelOrder(_vm.order._id)
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (_vm.order.status == 'unpaid') ? _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.paySelect(_vm.order._id)
      }
    }
  }, [_vm._v("付款")]) : _vm._e(), _vm._v(" "), (_vm.order.shippingInfo) ? _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.expressInfo(_vm.order._id)
      }
    }
  }, [_vm._v("查看物流")]) : _vm._e()]), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "menus": _vm.payMethodList,
      "close-on-clicking-mask": false,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.toPay,
      "on-click-mask": function($event) {
        _vm.showPayList = false
      }
    },
    model: {
      value: (_vm.showPayList),
      callback: function($$v) {
        _vm.showPayList = $$v
      },
      expression: "showPayList"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ceafaa62"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList/OrderDetail.vue
// module id = 615
// module chunks = 0